import { Record, List } from 'immutable';
import type ErrorRecord from '~/data/ErrorRecord';
import Constants from '../constants';
import type InviteRequestListItemRecord from './InviteRequestListItemRecord';
import InviteRequestStatusCountRecord from './InviteRequestStatusCountRecord';

const keys: Fields = {
  isLoading: false,
  isHandlingAction: false,
  statusCount: new InviteRequestStatusCountRecord(),
  selectedStatus: Constants.PENDING,
  inviteRequests: List(),
  error: undefined,
};

interface Fields {
  isLoading: boolean;
  isHandlingAction: boolean;
  statusCount: InviteRequestStatusCountRecord;
  selectedStatus: string;
  inviteRequests: List<InviteRequestListItemRecord>;
  error?: ErrorRecord;
}

export default class InviteRequestListRecord extends Record<Fields>(keys) {}
